module.exports = __webpack_public_path__ + "static/img/status_empty_gift.354a35f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/status_empty_gift.png
// module id = z+jD
// module chunks = 1